export default function datePicker( $box = '' ) {
  const $dates = $( '.js-date', $box );

  webix.Date.startOnMonday = true;

  $.each( $dates, ( i, el ) => {
    const $container = $( el );
    const $input = $container.find( 'input' );
    const isTimeOnly = $container.data( 'time-only' ) === true;
    const defaultDate = $input.data( 'default-date' ) || new Date();
    const defaultTime = $input.val() || '18:30';

    $input.prop( 'readonly', true );

    const datepicker = $container.webix_datepicker( {
      value: isTimeOnly ? defaultTime : defaultDate,
      format: '%d.%m.%Y',
      responsive: true,
      height: 51,
      type: isTimeOnly ? 'time' : null,
      on: {
        onChange: ( newDate ) => {
          const day = newDate.getDate();
          const month = newDate.getMonth() + 1;
          const year = newDate.getFullYear();
          const hours = newDate.getHours();
          const minutes = newDate.getMinutes();
          const date = [
            day < 10 ? `0${ day }` : day,
            month < 10 ? `0${ month }` : month,
            year,
          ].join( '.' );
          const time = [
            hours < 10 ? `0${ hours }` : hours,
            minutes < 10 ? `0${ minutes }` : minutes,
          ].join( ':' );

          $input.val( isTimeOnly ? time : date );
        },
      },
    } );
  } );
}
